import axios from 'axios';

const ORG_ID = process.env.REACT_APP_ORG_ID || 'mncwest';

const api = axios.create({ baseURL: '/api', headers: { 'X-Org-Id': ORG_ID } });

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('mncwest_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('mncwest_token');
      if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin/login')
        window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

export default api;
